export function init(app) {
  app.ports.simpleConfirm.subscribe(prompt => {
    app.ports.simpleConfirmed.send(confirm(prompt));
  });

  app.ports.saveConfig.subscribe(config => {
    localStorage.setItem("memory-quiz-config", JSON.stringify(config));
  })

  app.ports.saveTags.subscribe(tags => {
    localStorage.setItem("memory-quiz-tags", JSON.stringify(tags));
  })

  app.ports.speak.subscribe(sentence => {
    console.log(`speak: ${sentence}`);
    if ("speechSynthesis" in window) {
      const uttr = new SpeechSynthesisUtterance(sentence);
      uttr.lang = 'en-US';
      speechSynthesis.speak(uttr);
    }
  })
}